module.exports = __webpack_public_path__ + "static/media/dnc_logo.8dc7820b.png";